export class Chart {
  Id: string;
  Layout: any;
  Data: any;
  Height: number;
  Width: number;

  get ChartHeightStr(): string {
    return this.Height + "px";
  }

  get Style(): any {
    if (this.Width) return { position: "relative", height: this.Height + "px", width: this.Width + "px" };

    return { position: "relative", height: this.Height + "px"};
  }

  constructor(layout: any, data: any, height: number, width: number = null) {
    this.Layout = layout;
    this.Data = data;
    this.Height = height;
    this.Width = width;
  }
}
